export const formatAmount = (amount: number, decimals = 2, minDecimals = 2) => {
  return new Intl.NumberFormat("en-EN", {
    minimumFractionDigits: decimals < minDecimals ? decimals : minDecimals,
    maximumFractionDigits: decimals,
  }).format(amount);
};

export const maskNumber = (value: string): string => {
  let maskedValue = value.replace(/[^0-9.]/g, "");

  // Ensure only one dot is present
  const parts = maskedValue.split(".");
  if (parts.length > 2) {
    maskedValue = parts[0] + "." + parts.slice(1).join("");
  }

  // Ensure at least one digit follows the dot
  if (maskedValue.includes(".")) {
    const [integerPart, decimalPart] = maskedValue.split(".");
    maskedValue = integerPart + "." + (decimalPart || "");
  }

  return maskedValue;
};
